import React, { Component } from "react";
import PropTypes from "prop-types";
import {
	Container,
	Dropdown,
	Icon,
	Image,
	Menu,
	Responsive,
	Segment,
	Sidebar,
	Visibility,
	Label,
	Popup,
	Header,
	Message,
	Button,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import UserPicto from "assets/menu/picto-user.png";
import displayRole from "utils/displayRole";
import { startDualScreen } from "utils/dualScreenUtils";
import HelpFolderDropDown from "./Others/HelpFolderDropDown";
import DropDownItemFolder from "./Others/DropDownItemFolder";
import WaitingFoldersDropDown from "./Others/WaitingFoldersDropDown";
import MobileUseHistoryMenuItem from "./Others/MobileUseHistoryMenuItem";
import QueueHelpFolders from "./Others/QueueHelpFolders";

// import { withTranslation } from 'react-i18next';

// import ws from 'reducers/ws';

const headerStyle = {
	backgroundColor: "#00c7b1",
};
const logoContainer = {
	display: "flex",
	alignItems: "center",
};

const centerContainer = {
	display: "flex",
	alignItems: "center",
	flex: 1,
	color: "white",
	gap: "5px",
};

const styles = {
	userContainer: {
		fontSize: "0.7em",
		textAlign: "right",
		lineHeight: "1.5em",
	},
	helpNurseActivated: {
		color: "orange",
		cursor: "pointer",
	},
	helpNurseBell: {
		color: "white",
		cursor: "pointer",
	},
	labelHelpNurseMe: {
		minWidth: "1em",
		minHeight: "1em",
		marginLeft: "-10px",
	},
	labelHelpNurseOthers: {
		minWidth: "1em",
		minHeight: "1em",
		marginLeft: "-5px",
	},
	connected: {
		color: "green",
		minWidth: "4px",
		miHheight: "4px",
		position: "relative",
		lineHeight: "4px",
		top: "6px",
		right: "20px",
	},
	notconnected: {
		color: "red",
		width: "10px",
		height: "10px",
		position: "absolute",
		bottom: "5px",
	},
	labelnotification: {
		marginLeft: "-21px",
		marginBottom: "-21px",
		zIndex: "5",
		fontSize: "9px",
	},
	bellIcon: {
		marginLeft: "-30px",
		marginBottom: "-18px",
		textShadow: "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff",
	},
};

const getWidth = () => {
	const isSSR = typeof window === "undefined";
	return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

class DesktopContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fixed: false,
			displayNurseFolderHelps: true,
		};
	}

	hideFixedMenu = () => this.setState({ fixed: false });
	showFixedMenu = () => this.setState({ fixed: true });
	render() {
		const {
			children,
			dualScreen,
			openDualScreen,
			closeDualScreen,
			toggleNurseHelp,
			nurseHelp,
			myNurseFolderHelps,
			statusWaitingFolderHelps,
			helpNurseGlobalParam,
			foldersWaiting,
			focusFolderManager,
			myOpenedFolders,
			closeAllMyOpenedFolder,
			acceptSupportFolderHelp,
			doneFolderHelp,
			cancelFolderHelp,
			goToResult,
			goToTubes,
			aliquotWaiting,
			goToAliquot,
			toggleHelpFolderOfMyCenter,
			helpFoldersMyCenter,
			openPreregisterModal,
			reasonOptions,
			getWaitingFolderHelp,
		} = this.props;
		const { center, box, live, tour, manualDegradation, manualDegradationMessage, usualState } = this.props.parameters;

		let centerIndex, boxIndex;
		if (center) {
			centerIndex = live.findIndex((elt) => elt.id === center.id);
			if (box && centerIndex > -1 && live[centerIndex]) {
				boxIndex = live[centerIndex].boxes.findIndex((elt) => elt.id === box.id);
			}
		}

		return (
			<Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
				<Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
					<Menu
						fixed="top"
						inverted
						size="large"
						style={{
							...headerStyle,
							height: this.props.path === "/home/foldermanager" ? 35 : 67.84,
						}}
					>
						<Container>
							<div style={logoContainer}>
								{/* <Image src={SilexLogo} alt="" style={{height: this.props.path === "/home/foldermanager" ? 20 : 35}}/> */}
							</div>

							<div style={centerContainer}>
								{(this.props.path === "/home/safeplaceqr" ||
									this.props.path === "/home/about" ||
									this.props.path === "/home/help" ||
									this.props.path === "/home/facturation" ||
									this.props.path === "/home/planning" ||
									this.props.path === "/home/issues") && (
									<Link to={"/home/lab"}>
										<Icon
											name="home"
											size="big"
											style={{
												marginLeft: 2,
												position: "relative",
												top: -2,
												color: "white",
											}}
										/>
									</Link>
								)}
								<div style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "space-evenly" }}>
									<div style={{ marginBottom: "5px" }}>
										{center?.name}
										{center && box && box.name ? ` - ${box.name}` : ""}
									</div>
									{center && tour && this.props.path !== "/home/foldermanager" && (
										<Popup
											wide
											content={
												<Header as="h4">
													<Icon name="clock outline" style={{ marginRight: "1px" }} />
													<Icon name="truck" />
													<Header.Content>
														Affichage de l’<b>heure de passage théorique</b> de la prochaine tournée et de l'heure prévue d'arrivée des tubes sur le
														plateau technique.
														<Header.Subheader>
															Information supplémentaire en cas d’avance ou de retard sur la tournée (à soustraire ou additionner à l’heure
															théorique).
														</Header.Subheader>
													</Header.Content>
												</Header>
											}
											position="bottom center"
											trigger={
												<Label color="orange" style={{ marginLeft: "10px", fontSize: "0.75em", padding: "2px 5px" }}>
													{" "}
													<Icon name="clock outline" style={{ marginRight: "1px" }} />
													<Icon name="truck" />
													{tour.plannedHour && tour.plannedHour.slice(0, -3)}
													{!!tour.delay &&
														(tour.delay > 4 ? (
															<Label color="red" size="mini" style={{ marginLeft: "10px" }} circular>
																+ {tour.delay}'
															</Label>
														) : tour.delay < -4 ? (
															<Label color="red" size="mini" style={{ marginLeft: "10px" }}>
																{tour.delay}'
															</Label>
														) : (
															""
														))}
													<Icon name="long arrow alternate right" style={{ marginRight: "1px", paddingLeft: "10px" }} />
													<Icon name="building outline" />
													{tour.expectedArrivalOnPT}{" "}
												</Label>
											}
										/>
									)}
								</div>
								{center && this.props.path !== "/home/foldermanager" && (
									<QueueHelpFolders queuedFolderHelps={this.props.queuedFolderHelps} getWaitingFolderHelp={getWaitingFolderHelp} />
								)}

								{center && box && box.name && centerIndex > -1 && live[centerIndex] && boxIndex > -1 && live[centerIndex].boxes[boxIndex] && (
									<Popup
										content={
											live[centerIndex].boxes[boxIndex].live === "red" ? (
												"Cliquez pour appeler le patient suivant"
											) : (
												<div>
													Cliquez pour modifier le statut en <br />« Ne pas déranger »
												</div>
											)
										}
										position="bottom center"
										trigger={
											<Label
												style={{ margin: "3px", marginLeft: "7px" }}
												as="a"
												onClick={(e) =>
													live[centerIndex].boxes[boxIndex].live === "red" ? this.props.setAvailableBox(box) : this.props.setBusyBox(box)
												}
												color={live[centerIndex].boxes[boxIndex].live === "#6ac906" ? "green" : "red"}
											>
												{live[centerIndex].boxes[boxIndex].live === "red" ? "Ne pas déranger" : "Je suis disponible"}{" "}
											</Label>
										}
									/>
								)}
							</div>

							{this.props.path !== "/home/foldermanager" && (
								<Menu.Menu position="right">
									<Menu.Item as="div">
										{
											<div style={styles.userContainer}>
												<b>
													{this.props.user.name}
													{this.props.user.rights === "ADMIN" && (
														<Icon
															name="star"
															size="tiny"
															style={{
																marginLeft: 2,
																position: "relative",
																top: -2,
															}}
														/>
													)}
												</b>
												<br />
												<i>{displayRole(this.props.user)}</i>
											</div>
										}
									</Menu.Item>
									{center && (
										<Popup
											content="CHECK-IN ORDONNANCES"
											position="bottom center"
											trigger={
												<Menu.Item as={Link} to="/home/safeplaceqr">
													<Icon name="qrcode" size="big" style={{ margin: 0 }} />
												</Menu.Item>
											}
										/>
									)}
									{center && (
										<WaitingFoldersDropDown
											foldersWaiting={foldersWaiting}
											focusFolderManager={focusFolderManager}
											goToResult={goToResult}
											goToTubes={goToTubes}
										/>
									)}
									{helpNurseGlobalParam && ((center && this.props.user.role === "NURSE") || this.props.user.role !== "NURSE") && (
										<HelpFolderDropDown
											nurseHelp={nurseHelp}
											myNurseFolderHelps={myNurseFolderHelps}
											statusWaitingFolderHelps={statusWaitingFolderHelps}
											toggleNurseHelp={toggleNurseHelp}
											focusFolderManager={focusFolderManager}
											acceptSupportFolderHelp={acceptSupportFolderHelp}
											doneFolderHelp={doneFolderHelp}
											cancelFolderHelp={cancelFolderHelp}
											isNurse={this.props.user.role === "NURSE"}
											helpFoldersMyCenter={helpFoldersMyCenter}
											toggleHelpFolderOfMyCenter={toggleHelpFolderOfMyCenter}
											user={this.props.user}
											openPreregisterModal={openPreregisterModal}
											reasonOptions={reasonOptions}
										/>
									)}
									{center && this.props.user.role === "NURSE" && aliquotWaiting && aliquotWaiting.folders && aliquotWaiting.folders.length > 0 && (
										<Popup
											content="Aliquots à scanner"
											position="bottom center"
											trigger={
												<Dropdown
													icon={
														<>
															<Icon name="lab" style={{ fontSize: "36px" }} />
															<Label circular color="red" style={styles.labelnotification}>
																{aliquotWaiting.folders.length}
															</Label>{" "}
														</>
													}
													item
												>
													<Dropdown.Menu style={{ maxHeight: "500px", overflow: "auto" }}>
														<Dropdown.Header icon="pin" content="Aliquots à scanner" />
														{aliquotWaiting.folders.map((f) => (
															<DropDownItemFolder
																key={`aliquotw-${f.id}`}
																folder={f}
																folderHelp={false}
																fastresult={false}
																aliquot={true}
																focusFolderManager={focusFolderManager}
																goToResult={goToResult}
																goToAliquot={goToAliquot}
															/>
														))}
													</Dropdown.Menu>
												</Dropdown>
											}
										/>
									)}
									{center && myOpenedFolders && myOpenedFolders.length > 0 && (
										<Popup
											content="Mes dossiers ouverts"
											position="bottom center"
											trigger={
												<Dropdown
													icon={
														<>
															<Icon name="folder open" style={{ fontSize: "36px" }} />
															<Label circular color="red" style={styles.labelnotification}>
																{myOpenedFolders.length}
															</Label>{" "}
														</>
													}
													item
												>
													<Dropdown.Menu style={{ maxHeight: "500px", overflow: "auto" }}>
														<Dropdown.Header icon="pin" content="Mes dossiers ouverts" />
														{myOpenedFolders &&
															myOpenedFolders.map((of) => (
																<DropDownItemFolder
																	key={`ddifo-${of.id}`}
																	folder={of}
																	fastresult={false}
																	folderHelp={false}
																	focusFolderManager={focusFolderManager}
																/>
															))}
														<Dropdown.Item
															onClick={() => closeAllMyOpenedFolder()}
															children={
																<>
																	<Icon name="user delete" />{" "}
																	<span style={{ fontSize: "0.8em", whiteSpace: "break-spaces" }}>Libérer tous mes dossiers ouverts</span>
																</>
															}
														/>
													</Dropdown.Menu>
												</Dropdown>
											}
										/>
									)}

									<Dropdown icon={<Image src={UserPicto} />} item simple>
										<Dropdown.Menu>
											{(this.props.user.rights === "ADMIN" || this.props.user.rights === "MANAGER") && (
												<Dropdown.Item
													as={Link}
													to={this.props.user.rights === "ADMIN" ? "/admin/general" : "/admin/users"}
													icon="settings"
													text="Administration"
												/>
											)}

											{center && <Dropdown.Item as={Link} to="/home/facturation" icon="credit card alternative" text="Résumé d'encaissement" />}
											<Dropdown.Item
												icon="log out"
												text="Se déconnecter"
												color="red"
												onClick={async (e) => {
													if (e !== undefined) e.preventDefault();
													await this.props.logout();
												}}
											/>
										</Dropdown.Menu>
									</Dropdown>
									{/* <Dropdown
										icon={<Image src={CatalogPicto} style={{ height: 40 }} />}
										item
									>
										<Dropdown.Menu>
											{this.props.parameters.urlTaking !== undefined && (
												<Dropdown.Item
													as='a'
													target='_blank'
													href={this.props.parameters.urlTaking}
													icon='log out'
													text='Manuel du labo'
												/>
											)}
											{this.props.parameters.urlCatalogExams !== undefined && (
												<Dropdown.Item
													as='a'
													target='_blank'
													href={this.props.parameters.urlCatalogExams}
													icon='settings'
													text='Catalogue sous-traitant'
												/>
											)}
										</Dropdown.Menu>
									</Dropdown> */}
									{dualScreen.isAvailable && (
										<Popup
											content="Double écran"
											position="bottom center"
											trigger={
												<Menu.Item
													as="a"
													onClick={() => {
														startDualScreen(openDualScreen, closeDualScreen);
													}}
												>
													<Icon name="desktop" size="big" style={{ margin: 0 }} />
												</Menu.Item>
											}
										/>
									)}

									{/* <Popup content="Plus d'informations"  position='bottom center' trigger={ */}
									<Dropdown icon={<Icon name="question circle outline" size="big" style={{ margin: 0 }} />} item simple>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/home/issues" icon="tty" text="Un problème ?" />
											<Dropdown.Item as={Link} to="/home/about" icon="info" text="Versions" />
											{this.props.parameters.urlTaking && (
												<Dropdown.Item as="a" target="_blank" href={this.props.parameters.urlTaking} icon="book" text="Manuel du labo" />
											)}

											{this.props.parameters.urlCatalogExams && (
												<Dropdown.Item
													as="a"
													target="_blank"
													href={this.props.parameters.urlCatalogExams}
													icon="address book"
													text="Catalogue d'analyses"
												/>
											)}
											{this.props.parameters.videos &&
												this.props.parameters.videos.length > 0 &&
												this.props.parameters.videos
													.filter((v) => v.url !== "")
													.map((v, i) => <Dropdown.Item key={`video${i}`} as="a" target="_blank" href={v.url} icon="video" text={v.label} />)}
										</Dropdown.Menu>
									</Dropdown>
									{/* />} */}
								</Menu.Menu>
							)}
							{this.props.path === "/home/foldermanager" && (
								<Menu.Menu position="right">
									{dualScreen.isAvailable && (
										<Menu.Item
											as="a"
											onClick={() => {
												startDualScreen(openDualScreen, closeDualScreen);
											}}
										>
											<Icon name="desktop" size="big" style={{ margin: 0 }} />
										</Menu.Item>
									)}
									<Menu.Item as="div">
										{helpNurseGlobalParam && this.props.user.role === "SECRETARY" && (
											<div>
												<Icon.Group size="big">
													<Icon name="bell" style={{ cursor: "pointer" }} onClick={() => toggleNurseHelp()} />
													{nurseHelp && <Icon corner="bottom right" name="play" color="green" />}
													{!nurseHelp && <Icon corner="bottom right" name="pause" color="red" />}
												</Icon.Group>
											</div>
										)}
									</Menu.Item>
								</Menu.Menu>
							)}
						</Container>
					</Menu>
					{manualDegradation && (
						<Message negative floating style={{ marginTop: this.props.path === "/home/foldermanager" ? "40px" : "68px" }} icon>
							<Icon name="bullhorn" />
							<Message.Content>
								<Message.Header>L'application Nurse est actuellement en maintenance.</Message.Header>
								{manualDegradationMessage}
							</Message.Content>
							<Button onClick={() => window.location.reload()}>Rafraichir</Button>
						</Message>
					)}
					{usualState && (
						<Message positive floating style={{ marginTop: this.props.path === "/home/foldermanager" ? "40px" : "68px" }} icon>
							<Icon name="bullhorn" />
							<Message.Content>
								<Message.Header>L'application Nurse fonctionne à nouveau correctement.</Message.Header>
								Si vous rencontrez des problèmes, rafraichissez la page à l'aide du bouton. <br />
								Si le problème persiste, n'hésitez pas à contacter le support{" "}
								<a href="mailto:helpdesk.mylabnurse@bionext.lu">helpdesk.mylabnurse@bionext.lu</a>.
							</Message.Content>
							<Button onClick={() => window.location.reload(true)}>Rafraichir</Button>
						</Message>
					)}
				</Visibility>

				{children}
			</Responsive>
		);
	}
}

DesktopContainer.propTypes = {
	children: PropTypes.node,
	path: PropTypes.string,
	logout: PropTypes.func,
	parameters: PropTypes.object,
	user: PropTypes.object,
	dualScreen: PropTypes.object,
	openDualScreen: PropTypes.func,
	closeDualScreen: PropTypes.func,
	toggleNurseHelp: PropTypes.func,
	nurseHelp: PropTypes.bool,
	myNurseFolderHelps: PropTypes.array,
	statusWaitingFolderHelps: PropTypes.object,
	helpNurseGlobalParam: PropTypes.bool,
	focusFolderManager: PropTypes.func,
	cancelFolderHelp: PropTypes.func,
};

class MobileContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sidebarOpened: false,
		};
	}

	handleSidebarHide = () => this.setState({ sidebarOpened: false });

	handleToggle = () => this.setState((prevState) => ({ ...prevState, sidebarOpened: !prevState.sidebarOpened }));

	render() {
		const { children, aliquotWaiting, myOpenedFolders, focusFolderManager, goToAliquot } = this.props;
		const { sidebarOpened } = this.state;
		const { center, box } = this.props.parameters;

		return (
			<Responsive
				as={Sidebar.Pushable}
				getWidth={getWidth}
				maxWidth={Responsive.onlyMobile.maxWidth}
				onClick={(e) => {
					if (e !== undefined) e.preventDefault();
					if (sidebarOpened) this.handleSidebarHide();
				}}
			>
				<Sidebar
					as={Menu}
					animation="push"
					inverted
					vertical
					visible={this.state.sidebarOpened}
					direction="right"
					style={{ backgroundColor: "#43b39e" }}
				>
					{this.props.path !== "/home/foldermanager" && (
						<div>
							<Menu.Item as="div">
								<b>
									{this.props.user.name}
									{this.props.user.rights === "ADMIN" && <Icon name="star" size="tiny" style={{ marginLeft: 2, position: "relative", top: -2 }} />}
								</b>
								<br />
								<i>{displayRole(this.props.user)}</i>
							</Menu.Item>

							{this.props.parameters.urlTaking !== undefined && (
								<Menu.Item as="a" target="_blank" href={this.props.parameters.urlTaking}>
									Manuel du labo
								</Menu.Item>
							)}

							{this.props.parameters.urlCatalogExams !== undefined && (
								<Menu.Item as="a" target="_blank" href={this.props.parameters.urlCatalogExams}>
									Catalogue sous-traitant
								</Menu.Item>
							)}
							{center && this.props.user.role === "NURSE" && aliquotWaiting && aliquotWaiting.folders && aliquotWaiting.folders.length > 0 && (
								<Menu.Menu>
									Aliquots à scanner
									{aliquotWaiting.folders.map((f) => (
										<MobileUseHistoryMenuItem
											key={`aliqu-mob-${f.id}`}
											folder={f}
											goToAliquot={() => goToAliquot()}
											focusFolderManager={focusFolderManager}
										/>
									))}
								</Menu.Menu>
							)}
							{myOpenedFolders && myOpenedFolders.length > 0 && (
								<Menu.Menu>
									Mes dossiers ouverts
									{myOpenedFolders.map((f) => (
										<MobileUseHistoryMenuItem key={`ddifo-mob-${f.id}`} folder={f} folderCode={f.code} focusFolderManager={focusFolderManager} />
									))}
								</Menu.Menu>
							)}

							<Menu.Item
								as="a"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									this.props.logout();
								}}
							>
								Se déconnecter
							</Menu.Item>
						</div>
					)}
				</Sidebar>

				<Sidebar.Pusher>
					<div
						style={{
							paddingTop: this.props.path === "/home/foldermanager" ? 40 : 67.84,
						}}
					>
						<Segment
							inverted
							textAlign="center"
							style={{
								backgroundColor: "#00c7b1",
								padding: this.props.path === "/home/foldermanager" ? "0" : "1em 0em",
								width: "100%",
								position: "fixed",
								zIndex: 10,
								top: 0,
								height: this.props.path === "/home/foldermanager" ? 40 : 67.84,
							}}
							vertical
						>
							<Container>
								<Menu inverted pointing secondary size="large" style={{ border: 0 }}>
									<div style={logoContainer}>
										{/* <Image src={SilexLogo} alt="" style={{height: this.props.path === "/home/foldermanager" ? 20 : 35}}/> */}
									</div>

									<div style={{ marginTop: 10 }}>
										{center?.name}
										{box ? ` - ${box.name}` : ""}
									</div>

									{this.props.path !== "/home/foldermanager" && (
										<Menu.Item
											position="right"
											onClick={() => {
												this.handleToggle();
											}}
										>
											<Icon name="sidebar" />
										</Menu.Item>
									)}
								</Menu>
							</Container>
						</Segment>

						{children}
					</div>
				</Sidebar.Pusher>
			</Responsive>
		);
	}
}

MobileContainer.propTypes = {
	children: PropTypes.node,
	path: PropTypes.string,
	logout: PropTypes.func,
	parameters: PropTypes.object,
	user: PropTypes.object,
};

export const ResponsiveContainer = ({
	children,
	logout,
	path,
	parameters,
	user,
	dualScreen,
	openDualScreen,
	closeDualScreen,
	toggleNurseHelp,
	myNurseFolderHelps,
	statusWaitingFolderHelps,
	helpNurseGlobalParam,
	foldersWaiting,
	aliquotWaiting,
	focusFolderManager,
	myOpenedFolders,
	closeAllMyOpenedFolder,
	acceptSupportFolderHelp,
	doneFolderHelp,
	cancelFolderHelp,
	goToResult,
	goToAliquot,
	goToTubes,
	ws,
	setAvailableBox,
	setBusyBox,
	toggleHelpFolderOfMyCenter,
	helpFoldersMyCenter,
	openPreregisterModal,
	reasonOptions,
	queuedFolderHelps,
	getWaitingFolderHelp,
}) => (
	<div>
		<DesktopContainer
			logout={logout}
			path={path}
			parameters={parameters}
			user={user}
			dualScreen={dualScreen}
			openDualScreen={openDualScreen}
			closeDualScreen={closeDualScreen}
			toggleNurseHelp={toggleNurseHelp}
			nurseHelp={user.nurseHelp}
			helpNurseGlobalParam={helpNurseGlobalParam}
			myNurseFolderHelps={myNurseFolderHelps}
			statusWaitingFolderHelps={statusWaitingFolderHelps}
			foldersWaiting={foldersWaiting}
			focusFolderManager={focusFolderManager}
			myOpenedFolders={myOpenedFolders}
			closeAllMyOpenedFolder={closeAllMyOpenedFolder}
			acceptSupportFolderHelp={acceptSupportFolderHelp}
			doneFolderHelp={doneFolderHelp}
			cancelFolderHelp={cancelFolderHelp}
			goToResult={goToResult}
			goToTubes={goToTubes}
			ws={ws}
			setAvailableBox={setAvailableBox}
			setBusyBox={setBusyBox}
			aliquotWaiting={aliquotWaiting}
			goToAliquot={goToAliquot}
			toggleHelpFolderOfMyCenter={toggleHelpFolderOfMyCenter}
			helpFoldersMyCenter={helpFoldersMyCenter}
			openPreregisterModal={openPreregisterModal}
			reasonOptions={reasonOptions}
			queuedFolderHelps={queuedFolderHelps}
			getWaitingFolderHelp={getWaitingFolderHelp}
		>
			{children}
		</DesktopContainer>
		<MobileContainer
			logout={logout}
			path={path}
			parameters={parameters}
			user={user}
			aliquotWaiting={aliquotWaiting}
			myOpenedFolders={myOpenedFolders}
			focusFolderManager={focusFolderManager}
			goToAliquot={goToAliquot}
		>
			{children}
		</MobileContainer>
	</div>
);

ResponsiveContainer.propTypes = {
	children: PropTypes.node,
	path: PropTypes.string,
	logout: PropTypes.func,
	parameters: PropTypes.object,
	user: PropTypes.object,
	dualScreen: PropTypes.object,
	openDualScreen: PropTypes.func,
	closeDualScreen: PropTypes.func,
	toggleNurseHelp: PropTypes.func,
	helpNurseGlobalParam: PropTypes.bool,
	focusFolderManager: PropTypes.func,
	myOpenedFolders: PropTypes.array,
	closeAllMyOpenedFolder: PropTypes.func,
	cancelFolderHelp: PropTypes.func,
	goToResult: PropTypes.func,
	goToTubes: PropTypes.func,
};
